import { createFileRoute } from '@tanstack/react-router'
import { useBreadcrumbFromRoute } from '@/hooks/use-breadcrumb-from-route'
import { SectionNavGrid } from '@/components/shared/section-nav-grid'
import {
  LayoutDashboard,
  Calendar,
  Users,
  DollarSign,
  CheckSquare,
} from 'lucide-react'

export const Route = createFileRoute('/_app/home')({
  component: HomeIndexPage,
})

function HomeIndexPage() {
  useBreadcrumbFromRoute()

  const navItems = [
    {
      title: 'Dashboard',
      url: '/dashboard',
      icon: LayoutDashboard,
      description: 'View your overview and insights',
    },
    {
      title: 'Calendar',
      url: '/calendar',
      icon: Calendar,
      description: 'Manage your schedule and events',
    },
    {
      title: 'Leads',
      url: '/leads',
      icon: Users,
      description: 'Track and manage leads',
    },
    {
      title: 'Events',
      url: '/events',
      icon: Calendar,
      description: 'Browse and manage events',
    },
    {
      title: 'Invoices',
      url: '/invoices',
      icon: DollarSign,
      description: 'View and manage invoices',
    },
    {
      title: 'Tasks',
      url: '/tasks',
      icon: CheckSquare,
      description: 'Organize your tasks',
    },
  ]

  return (
    <SectionNavGrid
      title="Home"
      description="Welcome to your workspace. Select a section to get started."
      items={navItems}
    />
  )
}
